import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { statisticsStyles } from '../../Styles/statisticsStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Header from '../../Common/Header'
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader-spinner'
import Moment from 'moment';
import AdminStats from './AdminStats';
import AgentStats from './AgentStats';
import lightBlue from "@material-ui/core/colors/lightBlue";
import { DateRangePicker } from 'react-date-range';
//import 'react-date-range/dist/styles.css'; // main style file
//import 'react-date-range/dist/theme/default.css'; // theme css file
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import '../../Styles/datePickerStyles.css';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ChartComponent from './ChartComponent';



const materialTheme = createMuiTheme({
    overrides: {
        MuiInputBase: {
            root: {
                " &$disabled": {
                    color: 'white',
                    cursor: 'pointer !important'
                }

            }
        },
        MuiFilledInput: {

            inputAdornedEnd: {
                padding: '3vh 1vw'
            }
        }
    }
})

@inject('statisticsStore', 'commonStore', 'userStore')
@observer
class StatsComponent extends React.Component {
    state = {
        startDate: Moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD-MMM-YYYY'),
        endDate: Moment(new Date()).format('DD-MMM-YYYY'),
        showDatePicker: false,
        selectionRange: {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        }
    }

    componentDidMount() {
        this.props.commonStore.setActiveTab('stats');
        let startDate = Moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY-MM-DD')
        let endDate = Moment(new Date()).format('YYYY-MM-DD')
        this.props.statisticsStore.getStatusReport(startDate, endDate)
    }

    renderDocWiseCount = () => {
        const { classes } = this.props;
        const { superAdminStats } = this.props.statisticsStore;
        return (
            <div style={{ display: 'flex' }}>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.navDoc} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{superAdminStats['aadhaar']}</div>
                        Aadhar
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.navDoc} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{superAdminStats['pan']}</div>
                        PAN Card
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.navDoc} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{superAdminStats['PAN_FORM']}</div>
                        PAN Form
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3', width: 'auto' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.navDoc} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{superAdminStats['rc']}</div>
                        Vehicle Registration Certificate
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.navDoc} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{superAdminStats['NEW_FORM']}</div>
                        Unsupported Docs
                    </div>
                    </div>
                </div>
            </div>
        )
    }

    renderCountData = () => {
        const { classes } = this.props;
        const { countData, totalCount } = this.props.statisticsStore;
        const { user } = this.props.userStore;
        return (
            <div style={{ display: 'flex' }}>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.importSmall} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{totalCount}</div>
                        Uploaded
                    </div>
                    </div>
                </div>
                {
                    user.userType === 'SUPER_ADMIN' ?
                        <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #ff4652' }}>
                            <div style={{ display: 'flex' }}>
                                <ReactSVG src={Images.progress} />
                                <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                                    <div style={{ color: 'white' }}>{countData['AI_PENDING']}</div>
                        AI Pending
                    </div>
                            </div>
                        </div> : null
                }
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #ff4652' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.draft} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{countData['REVIEW_PENDING']}</div>
                        In Draft
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #04bfb4' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.reviewed} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{countData['REVIEW_COMPLETE']}</div>
                        Reviewed
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #bba3f6' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.exported} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{countData['EXPORTED']}</div>
                        Exported
                    </div>
                    </div>
                </div>
            </div>
        )
    }

    handleSelect = (ranges) => {
        this.setState({
            selectionRange: ranges.selection,
            startDate: Moment(ranges.selection.startDate).format('DD-MMM-YYYY'),
            endDate: Moment(ranges.selection.endDate).format('DD-MMM-YYYY')
        })

    }

    getStats = () => {
        this.setState({ showDatePicker: false })
        const { startDate, endDate } = this.state
        let s = Moment(startDate).format('YYYY-MM-DD')
        let e = Moment(endDate).format('YYYY-MM-DD')
        this.props.statisticsStore.getStatusReport(s, e)

    }

    openDatePicker = () => {
        this.setState({ showDatePicker: true })
    }

    handleClickAway = () => {
        this.setState({ showDatePicker: false })
    }

    downloadReport = () => {
        this.props.statisticsStore.downloadReport()
    }

    render() {
        const { classes } = this.props;
        const { inProgress } = this.props.statisticsStore;
        const { user } = this.props.userStore;
        const { startDate, endDate, range, selectionRange, showDatePicker } = this.state;
        if (inProgress)
            return (
                <div style={{ height: '100%' }}>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <div style={{ height: '100%' }}>
                <div className={classes.outerContainer}>
                    <div style={{ flex: 2, display: 'flex', justifyContent: 'space-between', marginTop: '-1vh' }}><Typography className={classes.heading}>Usage Statistics</Typography>
                        <div style={{ cursor: 'pointer' }}>

                            <div className="rowFlex">
                                <ReactSVG src={Images.download} onClick={(e) => this.downloadReport()} style={{ marginTop: '2vh', marginRight: '1VW' }} />
                                <Button variant="contained" className={classes.button} type="submit" onClick={this.openDatePicker} fullWidth>
                                    {`${startDate}  -   ${endDate}`}
                                </Button>
                                {showDatePicker ? <ReactSVG style={{ marginTop: '3vh' }} src={Images.docRight} onClick={(e) => this.getStats()} /> : null}
                            </div>
                            {showDatePicker ?
                                <ClickAwayListener onClickAway={this.handleClickAway}>


                                    <div style={{ position: 'absolute', left: '55%', top: '10%' }} >
                                        <DateRangePicker direction="horizontal"
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            months={1}
                                            ranges={[selectionRange]}
                                            onChange={this.handleSelect}
                                            disabled={true}
                                            maxDate={new Date()}
                                            color="yellow"
                                        />
                                    </div>
                                </ClickAwayListener> : null}


                        </div>
                    </div>
                    <Header></Header>
                </div>
                <div className={classes.innerContainer}>
                    <div className={classes.subHeading}>Document Usage Reports</div>
                    <div className="colFlex">
                        {this.renderCountData()}
                        {
                            user.userType === 'SUPER_ADMIN' ?
                                <React.Fragment>
                                    <div className={classes.subHeading}>Document-wise Stats</div>
                                    {this.renderDocWiseCount()}
                                </React.Fragment> :
                                <div className="rowFlex">
                                    <AdminStats></AdminStats>
                                    <AgentStats></AgentStats>
                                </div>
                        }
                    </div>
                </div>
            </div >

        )
    }
}

export default withStyles(statisticsStyles, { withTheme: true })(withRouter(StatsComponent));
